"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* tslint:disable */
var React = require("react");
/* tslint:enable */
var Utilities_1 = require("../../../Utilities");
var BasePicker_1 = require("../BasePicker");
var BasePicker_types_1 = require("../BasePicker.types");
var SelectedItemDefault_1 = require("./PeoplePickerItems/SelectedItemDefault");
var SuggestionItemDefault_1 = require("./PeoplePickerItems/SuggestionItemDefault");
require("./PeoplePicker.scss");
var BasePeoplePicker = /** @class */ (function (_super) {
    tslib_1.__extends(BasePeoplePicker, _super);
    function BasePeoplePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BasePeoplePicker;
}(BasePicker_1.BasePicker));
exports.BasePeoplePicker = BasePeoplePicker;
var MemberListPeoplePicker = /** @class */ (function (_super) {
    tslib_1.__extends(MemberListPeoplePicker, _super);
    function MemberListPeoplePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MemberListPeoplePicker;
}(BasePicker_1.BasePickerListBelow));
exports.MemberListPeoplePicker = MemberListPeoplePicker;
/**
 * Standard People Picker.
 */
var NormalPeoplePicker = /** @class */ (function (_super) {
    tslib_1.__extends(NormalPeoplePicker, _super);
    function NormalPeoplePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NormalPeoplePicker.defaultProps = {
        onRenderItem: function (props) { return React.createElement(SelectedItemDefault_1.SelectedItemDefault, tslib_1.__assign({}, props)); },
        onRenderSuggestionsItem: function (props, itemProps) { return SuggestionItemDefault_1.SuggestionItemNormal(tslib_1.__assign({}, props), tslib_1.__assign({}, itemProps)); },
        createGenericItem: createGenericItem
    };
    return NormalPeoplePicker;
}(BasePeoplePicker));
exports.NormalPeoplePicker = NormalPeoplePicker;
/**
* Compact layout. It uses small personas when displaying search results.
*/
var CompactPeoplePicker = /** @class */ (function (_super) {
    tslib_1.__extends(CompactPeoplePicker, _super);
    function CompactPeoplePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CompactPeoplePicker.defaultProps = {
        onRenderItem: function (props) { return React.createElement(SelectedItemDefault_1.SelectedItemDefault, tslib_1.__assign({}, props)); },
        onRenderSuggestionsItem: function (props, itemProps) { return SuggestionItemDefault_1.SuggestionItemSmall(tslib_1.__assign({}, props), tslib_1.__assign({}, itemProps)); },
        createGenericItem: createGenericItem
    };
    return CompactPeoplePicker;
}(BasePeoplePicker));
exports.CompactPeoplePicker = CompactPeoplePicker;
/**
 * MemberList layout. The selected people show up below the search box.
 */
var ListPeoplePicker = /** @class */ (function (_super) {
    tslib_1.__extends(ListPeoplePicker, _super);
    function ListPeoplePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListPeoplePicker.defaultProps = {
        onRenderItem: function (props) { return React.createElement(SelectedItemDefault_1.SelectedItemDefault, tslib_1.__assign({}, props)); },
        onRenderSuggestionsItem: function (props, itemProps) { return SuggestionItemDefault_1.SuggestionItemNormal(tslib_1.__assign({}, props), tslib_1.__assign({}, itemProps)); },
        createGenericItem: createGenericItem
    };
    return ListPeoplePicker;
}(MemberListPeoplePicker));
exports.ListPeoplePicker = ListPeoplePicker;
function createGenericItem(name, currentValidationState, allowPhoneInitials) {
    var personaToConvert = {
        key: name,
        primaryText: name,
        imageInitials: '!',
        ValidationState: currentValidationState
    };
    if (currentValidationState !== BasePicker_types_1.ValidationState.warning) {
        personaToConvert.imageInitials = Utilities_1.getInitials(name, Utilities_1.getRTL(), allowPhoneInitials);
    }
    return personaToConvert;
}
exports.createGenericItem = createGenericItem;
//# sourceMappingURL=PeoplePicker.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/pickers/PeoplePicker/PeoplePicker.js
// module id = 1696
// module chunks = 0